// Vendor
import { CommonModule } from '@angular/common';
// Modules
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class SecurityHeaderDropdownModule {
}
SecurityHeaderDropdownModule.ɵfac = function SecurityHeaderDropdownModule_Factory(t) { return new (t || SecurityHeaderDropdownModule)(); };
SecurityHeaderDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SecurityHeaderDropdownModule });
SecurityHeaderDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule] });
